export const PAGE_COUNT = 20;
export const PUBLIC_COMPANY_LIST = [
  '전체',
  '경찰청',
  '고용노동부',
  '공정거래위원회',
  '관세청',
  '교육부',
  '국가보훈처',
  '국무조정실',
  '국민안전처',
  '국방부',
  '국토교통부',
  '금융위원회',
  '기상청',
  '기획재정부',
  '농림축산식품부',
  '농촌진흥청',
  '문화재청',
  '문화체육관광부',
  '미래창조과학부',
  '방송통신위원회',
  '방위사업청',
  '법무부',
  '보건복지부',
  '산림청',
  '산업통상자원부',
  '식품의약품안전처',
  '여성가족부',
  '외교부',
  '원자력안전위원회',
  '인사혁신처',
  '중소기업청',
  '통일부',
  '특허청',
  '해양수산부',
  '행정자치부',
  '환경부',
];
